import script from "./SogFlexRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./SogFlexRow.vue?vue&type=script&setup=true&lang=ts"

import "./SogFlexRow.vue?vue&type=style&index=0&id=7f0eead8&lang=css"

const __exports__ = script;

export default __exports__